import { type SVGProps } from 'react';

/**
 * Esempio "Numero colonne": campo con valore 2 accanto a un campo con 1 —
 * la riga vale 3 colonne, il campo occupa 2/3.
 * source: widget-config-col-2-1.svg
 */
export function ColSpanExampleTwoOne(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1411.24 204.6"
      width="100%"
      aria-hidden="true"
      {...props}
    >
      {/* Campo con Numero colonne 2 (pieno) */}
      <path fill="#16395e" d="M936.88,0v162.08H0V0h936.88" />
      {/* Campo con Numero colonne 1 (bordo) */}
      <g>
        <rect fill="#fff" x="947.38" y="2.5" width="459.44" height="157.08" />
        <path
          fill="#16395e"
          d="M1404.32,5v152.08h-454.44V5h454.44M1409.32,0h-464.44v162.08h464.44V0h0Z"
        />
      </g>
      {/* Cifra "1" */}
      <path
        fill="#16395e"
        d="M1196.01,32.33v92.4h-19.32V54.17l-20.02,12.88-8.82-14.42,30.52-20.3h17.64Z"
      />
      {/* Righello delle 3 colonne */}
      <path fill="#b4c4d6" d="M464.44,170.08v34.52H0v-34.52h464.44" />
      <path fill="#b4c4d6" d="M936.88,170.08v34.52h-464.44v-34.52h464.44" />
      <path fill="#b4c4d6" d="M1409.32,170.08v34.52h-464.44v-34.52h464.44" />
      {/* Cifra "2" */}
      <path
        fill="#fff"
        d="M496.79,124.73h-59.92v-16.38l19.74-20.02c7-7.19,11.88-12.69,14.63-16.52,2.75-3.83,4.13-7.91,4.13-12.25s-1.14-7.4-3.43-9.17c-2.29-1.77-5.53-2.66-9.73-2.66-6.25,0-13.07.56-20.44,1.68l-3.36.42-.98-14.98c9.15-2.8,18.62-4.2,28.42-4.2,19.6,0,29.4,8.82,29.4,26.46,0,6.91-1.49,12.88-4.48,17.92-2.99,5.04-8.4,11.15-16.24,18.34l-16.1,14.56h38.36v16.8Z"
      />
    </svg>
  );
}
